/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import Skeleton from 'react-loading-skeleton';

import raProductImg from '@assets/ra-product.png';
import raImage from '@assets/Return assurance.png';
import odImage from '@assets/Delivery guarantee.png';
import irImage from '@assets/Instand refund.png';
import bpImage from '@assets/Buyer protection.png';
import asImage from '@assets/Assured_sale.svg';
import bgImage from '@assets/buyback_guarantee.svg';
import ewImage from '@assets/extended_warranty.svg';
import { PRODUCT_NAME } from '@constants';
import classes from './ProductCard.module.css';
import { ProductStatus, ProductProcessTips } from '../Dashboard/content';

const {
  RETURN_ASSURANCE, BUYER_PROTECTION, SHIPPING_PROTECTION, GREEN_SHIPPING_PROTECTION, BUYBACK_GUARANTEE, EXTENDED_WARRANTY, INSTANT_REFUND, ESTIMATED_DELIVERY_DATE, ASSURED_SALE, DELIVERY_GUARANTEE, WORRY_FREE_PURCHASE, RETURNABLE,
} = PRODUCT_NAME;

const images = {
  [RETURN_ASSURANCE]: raImage,
  [RETURNABLE]: raImage,
  [BUYER_PROTECTION]: bpImage,
  [INSTANT_REFUND]: irImage,
  [ESTIMATED_DELIVERY_DATE]: odImage,
  [SHIPPING_PROTECTION]: bpImage,
  [GREEN_SHIPPING_PROTECTION]: bpImage,
  [DELIVERY_GUARANTEE]: bpImage,
  [WORRY_FREE_PURCHASE]: bpImage,
  [ASSURED_SALE]: asImage,
  [BUYBACK_GUARANTEE]: bgImage,
  [EXTENDED_WARRANTY]: ewImage,
};
const LearnMorePart = ({ learnMore }) => learnMore && <a href={learnMore} target="_blank" className={classes.learn_more} rel="noreferrer">{'Learn more >'}</a>;

function ProductSkeleton() {
  return (
    <div className={classes.content}>

      <div className={classes.product_card}>
        <header className={classes.product_header}>
          {/* <span className={classes.product_img}></span> */}
          <Skeleton containerClassName={classes.product_img} style={{ height: '100%', width: '100%' }} />
          <Skeleton containerClassName={classes.product_title} style={{ height: '100%', width: '200PX' }} />
        </header>
        <div className={classes.desc_list}>
          <Skeleton containerClassName={classes.product_img} style={{ height: '100%', width: '100%', margin: '10px 0' }} />
          <Skeleton containerClassName={classes.product_img} style={{ height: '100%', width: '100%', margin: '10px 0' }} />
          <Skeleton containerClassName={classes.product_img} style={{ height: '100%', width: '100%', margin: '10px 0' }} />
        </div>
        <footer className={classes.product_footer}>
          <Skeleton containerClassName={classes.product_img} style={{ height: '100%', width: '90PX' }} />
        </footer>

      </div>
    </div>
  );
}

const ProductCard = (props) => {
  const {
    title, brief, involvedStatus, footer, isLoading, liveDate, learnMore,
  } = props || {};
  // const images = [raImage, null, null, null, bpImage, irImage, null, odImage, bpImage, raImage, raImage, raImage];
  if (isLoading) return <ProductSkeleton />;

  return (
    <div className={classes.product_card}>
      <header className={classes.product_header}>
        <img className={classes.product_img} src={images[title] || raProductImg} alt={title} />
        <div className={classes.product_title}>{title}</div>
        {involvedStatus !== 'void' && <ProductStatus status={involvedStatus} />}
        <LearnMorePart learnMore={learnMore} />
      </header>
      {title === RETURN_ASSURANCE && <ProductProcessTips involvedStatus={involvedStatus} liveDate={liveDate} />}
      <ul className={classes.desc_list}>
        {brief?.split('___').map((desc) => (
          <li key={desc}>{desc}</li>
        ))}
      </ul>
      <footer className={classes.product_footer}>
        {footer}
      </footer>
    </div>
  );
};
export default ProductCard;
